import { handleActions } from 'redux-actions';
import { defaultUsernameRenameWidgetState } from './defaults';
import { UsernameRenameWidgetData } from './types';
import { initMyAccountPage } from '../../actions';
import {
  makeSpecificSaveableWidgetDataMergeFunction,
  INITIAL_SAVE_REQUEST_META,
  saveableWidgetRequestMetaReducer,
} from '../utils';
import {
  setUsernameRenameWidgetPassword,
  setUsernameRenameWidgetUsername,
  saveUsernameRename,
  saveUsernameRenameSuccess,
  saveUsernameRenameFailure,
} from './actions';

const mergeUsernameRenameWidgetDataChange =
  makeSpecificSaveableWidgetDataMergeFunction(
    defaultUsernameRenameWidgetState,
    widgetState => {
      return (
        widgetState.currentData.username !== widgetState.initialData.username
      );
    },
    true
  );

export default handleActions<UsernameRenameWidgetData, any>(
  {
    [initMyAccountPage.toString()]: (
      state,
      action: ReturnType<typeof initMyAccountPage>
    ) => {
      const personalInformationData: UsernameRenameWidgetData['initialData'] = {
        username: action.payload.data.session.user.username ?? '',
        password: '',
        isRenameEligible: action.payload.data.usernameRename?.isRenameEligible,
        hasRecentRename: action.payload.data.usernameRename?.hasRecentRename,
        lockoutExpirationTs:
          action.payload.data.usernameRename?.lockoutExpirationTs,
      };
      return {
        initialData: personalInformationData,
        currentData: personalInformationData,
        isDirty: false,
        saveRequest: INITIAL_SAVE_REQUEST_META,
      };
    },
    [setUsernameRenameWidgetUsername.toString()]: (
      state,
      action: ReturnType<typeof setUsernameRenameWidgetUsername>
    ) =>
      mergeUsernameRenameWidgetDataChange(state, {
        username: action.payload.username,
      }),
    [setUsernameRenameWidgetPassword.toString()]: (
      state,
      action: ReturnType<typeof setUsernameRenameWidgetPassword>
    ) =>
      mergeUsernameRenameWidgetDataChange(state, {
        password: action.payload.password,
      }),
    ...saveableWidgetRequestMetaReducer({
      initialAction: saveUsernameRename,
      successAction: saveUsernameRenameSuccess,
      failureAction: saveUsernameRenameFailure,
    }),
  },
  defaultUsernameRenameWidgetState
);
